module.exports = __webpack_public_path__ + "img/pro_dialog.fec377fb.png";